<template>
    <div class="pay-city-component">
        <el-dropdown @command="handleCommand" class="project-container" placement="bottom-start">
            <span class="el-dropdown-link">
                学员所在区：{{city}}<img src="@/assets/images/order/payPull.svg" />
            </span>
            <el-dropdown-menu slot="dropdown" class="project-dropdown">
                <el-dropdown-item v-for="item in cityList" :key="item.location" :command="item">{{item.locationName}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
export default {
  props: {
    cityList: {
        type: Array,
        default: () => {
            return []
        }
    },
    payOrderId: {
        type: String,
        default: ''
    },
    location: {
        type: String,
        default: ''
    },
    locationName: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
        city: this.locationName,
        cityLocation: this.location,
        dialogVisible: false
    }
  },
  methods: {
    handleCommand(command) {
        this.dialogVisible =  true
        this.handleChoose(command)
    },
    handleChoose(command) {
        let city = command.locationName
        this.$confirm({
        title: '变更区域',
        content: `您确认将本订单所在区域变更为“${city}”`,
        sureBtnText: "确定"
      })
        .then(() => {
            this.cityLocation = command.location
            this.axios({
                method: 'post',
                url: '/gw/order-rest/api/order_rest/pay/orderAreaSubject/update',
                params: {
                    payOrderId: this.payOrderId,
                    location: this.cityLocation
                }
            }).then(res => {
                if (res.data.code === 200) {
                    this.city = command.locationName
                    this.$emit('init')
                } else {
                    this.$alert(res.data.msg)
                }
            })
        })
        .catch(err => { });
    }
  }
}
</script>
<style lang="less">
.pay-city-component {
    margin: 0 auto 15px;
    background-color: #fff;
    padding: 15px 25px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    font-size: 14px;
    color: #666;
  
}
.project-dropdown{
    //设置高度才能显示出滚动条 !important
    height:200px; 
    overflow: auto;
    width: 300px;
    left: 150px;
}
.project-dropdown::-webkit-scrollbar
{
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
}
.project-dropdown::-webkit-scrollbar-track
{
    //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
}
</style>

